package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_cash_register


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("createCashRegister")
    val createCashRegister: CreateCashRegister?,
    @SerialName("__typename")
    val typename: String?
)